import { Matrix4, Vector3 } from "three";
/**
 * Provides matrices utility functions
 * @class MatrixUtils
 * @static
 * @constructor
 */
export class MatrixUtils {
    /**
     * @method Mat4MulVec3
     * @static
     * @param {Matrix4} matrix4
     * @param {Vector3} vector3
     * @return {Matrix4}
     */
    static Mat4MulVec3(matrix4, vector3) {
        const vec = [vector3.x, vector3.y, vector3.z, 1];
        const resVec = new Vector3();
        resVec.x =
            matrix4.elements[0] * vec[0] +
                matrix4.elements[4] * vec[1] +
                matrix4.elements[8] * vec[2] +
                matrix4.elements[12];
        resVec.y =
            matrix4.elements[1] * vec[0] +
                matrix4.elements[5] * vec[1] +
                matrix4.elements[9] * vec[2] +
                matrix4.elements[13];
        resVec.z =
            matrix4.elements[2] * vec[0] +
                matrix4.elements[6] * vec[1] +
                matrix4.elements[10] * vec[2] +
                matrix4.elements[14];
        const w = matrix4.elements[3] * vec[0] +
            matrix4.elements[7] * vec[1] +
            matrix4.elements[11] * vec[2] +
            matrix4.elements[15];
        resVec.x = resVec.x / w;
        resVec.y = resVec.y / w;
        resVec.z = resVec.z / w;
        return resVec;
    }
    static ZoomMatrix(screenwidth, screenheight, imagewidth, imageheight, maxzoom, zoom, panx, pany) {
        const mat = new Matrix4();
        const maxwidth = Math.pow(2, maxzoom);
        const x0 = -(maxwidth * panx) / (imagewidth * zoom) - 1;
        const y0 = (2 * (imageheight + (maxwidth * (pany - (screenheight - 1))) / (2 * zoom))) / imageheight - 1;
        const x1 = -(maxwidth * (panx - (screenwidth - 1))) / (imagewidth * zoom) - 1;
        const y1 = (2 * (imageheight + (maxwidth * pany) / (2 * zoom))) / imageheight - 1;
        mat.elements[0] = 0.5 * Math.abs(x0 - x1);
        mat.elements[4] = 0;
        mat.elements[8] = 0;
        mat.elements[12] = x0 + 0.5 * Math.abs(x0 - x1);
        mat.elements[1] = 0;
        mat.elements[5] = 0.5 * Math.abs(y0 - y1);
        mat.elements[9] = 0;
        mat.elements[13] = y0 + 0.5 * Math.abs(y0 - y1);
        mat.elements[2] = 0;
        mat.elements[6] = 0;
        mat.elements[10] = 1;
        mat.elements[14] = 0;
        mat.elements[3] = 0;
        mat.elements[7] = 0;
        mat.elements[11] = 0;
        mat.elements[15] = 1;
        return mat;
    }
    static ProjectionFromCamera(width, height, pixelsize, n, f) {
        const mat = new Matrix4();
        const fovx = 2.0 * Math.atan((0.5 * width * pixelsize) / n);
        const fovy = 2.0 * Math.atan((0.5 * height * pixelsize) / n);
        const w = 1 / Math.tan(fovx * 0.5);
        const h = 1 / Math.tan(fovy * 0.5);
        const r10 = (f + n) / (n - f);
        const r11 = (2 * f * n) / (n - f);
        mat.elements[0] = w;
        mat.elements[4] = 0;
        mat.elements[8] = 0;
        mat.elements[12] = 0;
        mat.elements[1] = 0;
        mat.elements[5] = h;
        mat.elements[9] = 0;
        mat.elements[13] = 0;
        mat.elements[2] = 0;
        mat.elements[6] = 0;
        mat.elements[10] = r10;
        mat.elements[14] = r11;
        mat.elements[3] = 0;
        mat.elements[7] = 0;
        mat.elements[11] = -1;
        mat.elements[15] = 0;
        return mat;
    }
}
//# sourceMappingURL=matrixutils.js.map